export default __webpack_public_path__ + "static/media/reset.416e6e5b.svg";